import React from 'react'

const MonthlyTable = ({ title, characters, weaponSeries }) => (
  <div className="overflow-x-auto">
    <div className="flex items-center  justify-center overflow-hidden">
      <div className="lg:w-5/6">
        <div className="shadow-md rounded my-6">
          <table className="min-w-max w-full table-auto">
            <thead>
              <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
                <th className="py-3 px-6 text-left">{title}</th>
              </tr>
            </thead>
            <tbody className="text-gray-600 text-sm font-light">
              {characters.map((character) => (
                <tr className="border-b border-gray-200 bg-white hover:bg-gray-100">
                  <td className="py-3 px-6 text-left whitespace-nowrap">
                    <div className="flex items-center">
                      {character.image}
                      <span className="font-medium">{character.name}</span>
                    </div>
                  </td>
                </tr>
              ))}
              <tr className="border-b border-gray-200  bg-white hover:bg-gray-100">
                <td className="py-3 px-6 text-left whitespace-nowrap">
                  <div className="flex items-center">
                    {weaponSeries.weapons.map((weapon) => (<p>{weapon}</p>))}
                    <span className="font-medium">{weaponSeries.name}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
)

export default MonthlyTable
